import { useEffect, useState } from "react";
import { useGetAllTechnicianFromUsersQuery } from "../Redux/service/Technician/Technician";

const PAGE_SIZE = 10;

export function useInfiniteTechnicianOptions(searchTerm = "") {
	const [page, setPage] = useState(1);
	const [accumulated, setAccumulated] = useState([]);

	useEffect(() => {
		setPage(1);
		setAccumulated([]);
	}, [searchTerm]);

	const { data, isFetching } = useGetAllTechnicianFromUsersQuery(
		{ page, pageSize: PAGE_SIZE, search: searchTerm },
		{ refetchOnMountOrArgChange: true }
	);

	useEffect(() => {
		const list = data?.fieldWorkers;
		if (!list) return;
		setAccumulated((prev) => (page === 1 ? list : [...prev, ...list]));
	}, [data, page]);

	const hasMore = (data?.fieldWorkers?.length ?? 0) === PAGE_SIZE;

	const options = accumulated.map((user) => ({
		label: user.name,
		value: `${user.id}`,
	}));

	return {
		options,
		isFetching,
		hasMore,
		loadMore: () => {
			if (hasMore && !isFetching) setPage((prev) => prev + 1);
		},
	};
}
